import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Space } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface LoginProps {
  onLogin: (user: any) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    setError('');

    try {
      // 模拟登录API调用
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // 模拟用户数据
      const mockUsers = [
        { 
          id: 1, 
          username: 'admin', 
          password: 'admin123', 
          role: 'super_admin',
          name: '超级管理员',
          avatar: 'https://api.dicebear.com/7.x/miniavs/svg?seed=admin'
        },
        { 
          id: 2, 
          username: 'manager', 
          password: 'manager123', 
          role: 'admin',
          name: '系统管理员',
          avatar: 'https://api.dicebear.com/7.x/miniavs/svg?seed=manager'
        },
        { 
          id: 3, 
          username: 'operator', 
          password: 'operator123', 
          role: 'operator',
          name: '操作员',
          avatar: 'https://api.dicebear.com/7.x/miniavs/svg?seed=operator'
        },
        { 
          id: 4, 
          username: 'viewer', 
          password: 'viewer123', 
          role: 'viewer',
          name: '查看者',
          avatar: 'https://api.dicebear.com/7.x/miniavs/svg?seed=viewer'
        }
      ];

      const user = mockUsers.find(u => u.username === values.username && u.password === values.password);
      
      if (user) {
        // 保存用户信息到localStorage
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('loginTime', Date.now().toString());
        onLogin(user);
      } else {
        setError('用户名或密码错误');
      }
    } catch (err) {
      setError('登录失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20
    }}>
      <Card style={{ width: 400, boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <SafetyOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
          <Title level={2} style={{ margin: 0, color: '#1890ff' }}>
            AI智能机器人管理系统
          </Title>
          <Text type="secondary">请登录以访问系统</Text>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}

        <Form
          name="login"
          onFinish={handleLogin}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ width: '100%', height: 40 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ marginTop: 24, padding: 16, background: '#f5f5f5', borderRadius: 8 }}>
          <Text strong style={{ display: 'block', marginBottom: 8 }}>测试账号：</Text>
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Text code>admin / admin123 (超级管理员)</Text>
            <Text code>manager / manager123 (系统管理员)</Text>
            <Text code>operator / operator123 (操作员)</Text>
            <Text code>viewer / viewer123 (查看者)</Text>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Login;
